export const modalId = 'ConfirmChangeFromRecurrenceToRegularOrderModal'
